import { AuthService } from "../../shared/models/auth.service";
import { Injectable, Inject } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { WeGoConfig, IAPIResponse, DataListModel } from "../../shared/config";

@Injectable()
export class TwoFAService {
  constructor(private authService: AuthService, private http: Http) { }

  public GetTwoFaGoogleSetup(): Observable<IAPIResponse> {
    let getTwoFaUrl = WeGoConfig.API_GET_TWOFA_GOOGLE_SETUP_DETAILS;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getTwoFaUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public VerifyTwoFaTotp(totp: string): Observable<IAPIResponse> {
    let getTwoFaUrl = WeGoConfig.API_VERIFY_TWOFA_TOTP;
    getTwoFaUrl = getTwoFaUrl + "?totp=" + totp;

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getTwoFaUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public SendEmailOTP(): Observable<IAPIResponse> {
    let getTwoFaUrl = WeGoConfig.API_SEND_TWOFA_EMAIL_CODE;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getTwoFaUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }


  public VerifyTwoFaEmailOtp(totp: string): Observable<IAPIResponse> {
    let getTwoFaUrl = WeGoConfig.API_VERIFY_EMAIL_CODE;
    getTwoFaUrl = getTwoFaUrl + "?otp=" + totp;

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getTwoFaUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/twofa/models/TwoFa.service.ts